import { UserV3ResponseDto } from '@helios/frontend-api-v2-client';

export type ConnectStatus = 'started' | 'authorizing' | 'completed';
export type InverterType = 'solaredge' | 'enphase' | 'other';

export type UserSettings = NonNullable<UserV3ResponseDto['settings']>;

export type UtilityNotSupported = NonNullable<UserSettings['utilityNotSupported']>;

export type UserSegmentation = NonNullable<UserV3ResponseDto['segmentation']>;

export const UserSource = {
  salesRevamp: 'sales-revamp',
  subscriptionSolar: 'subscription-solar',
  palmettoPPA: 'palmetto-ppa',
  palmettoProtect: 'palmetto-protect',
  homeTransfer: 'home-transfer',
  epc: 'epc',
  luminance: 'luminance',
  organic: 'organic',
  tcd: 'tcd',
  catalyst: 'catalyst',
} as const;
export type UserSource = NonNullable<UserV3ResponseDto['source']>;

export type UserProperty = UserV3ResponseDto['properties'][number];

export type ApiUser = UserV3ResponseDto;

export type UserProjectResponse = NonNullable<UserV3ResponseDto['projects']>[number];

export type Signature = UserV3ResponseDto['signatures'][number];

export type User = ApiUser;

export const LocalizationLanguages = {
  English: 'en-US',
  Spanish: 'es-US',
} as const;
export type LocalizationLanguages = NonNullable<UserV3ResponseDto['languageCode']>;

export type UpdateUser = Partial<User> & {
  streetAddress?: string;
  city?: string;
  stateCode?: string;
  zip?: string;
};

export type BankAccountValidationStatus = 'pending' | 'valid' | 'invalid' | 'error' | 'unavailable';
export type BankAccountInvalidReason = 'accountClosed' | 'noMatchOrNotFound';
export interface BankAccountValidationResponse {
  status?: BankAccountValidationStatus;
  invalidReason?: BankAccountInvalidReason;
}
export interface BankAccountValidationResponseWithRequestLimit extends BankAccountValidationResponse {
  requestLimitMet: boolean;
}

export enum FinancialAccountProductType {
  ppa = 'ppa',
  lease = 'lease',
}

export enum FinancialAccountProduct {
  solar = 'solar',
  heatPump = 'heatPump',
  utilityRatePlan = 'utilityRatePlan',
  waterHeater = 'waterHeater',
}

export enum FinancialAccountSource {
  sabal = 'sabal',
  lightEnergy = 'lightEnergy',
}
export type FinancialAccount = UserV3ResponseDto['financeAccounts'][number];

export type SabalProgramType = 'hvac' | 'solar' | 'doePr' | 'newHomes' | 'newCommunity' | 'energyBackup' | 'waterHeater' | 'geothermal' | 'consumerSolar' | 'generator';

export interface SabalAccount {
  id: string;
  organizationName: string;
  programType: SabalProgramType;
}
